export const quotaAvailabilitySpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Timeoff ID',
    name: 'TIMEOFF_TYPE_ID',
    type: 'Integer',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Timeoff Name',
    name: 'TIMEOFF_NAME',
    type: 'Text',
  },
]